<template>
  <div class="home-backimg">
    <div>
      <carousel />
    </div>
    <div>
      <Introduction />
    </div>
    <div>
      <advantage />
    </div>
    <div>
      <productSystem />
    </div>
    <div>
      <cooperation />
    </div>
    <div>
      <newscenter />
    </div>
  </div>
</template>

<script setup>
import {
  defineComponent,
} from 'vue'
import carousel from "./carousel.vue"
import Introduction from "./Introduction.vue"
import advantage from "./advantage.vue"
import productSystem from "./productSystem.vue"
import cooperation from "./cooperation.vue"
import newscenter from "./newscenter.vue"


</script>
<style scoped>
.home-backimg {
  height: 100%;
}
</style>
